import { useEffect, useState } from 'react'

/**
 * Provides a useUserAgent hook that will return isIOS, isAndroid, and osName
 * It is ssr/ssg safe as navigator.userAgent is only called in the browser
 */
export const useUserAgent = () => {
  const [isIOS, setIsIOS] = useState(false)
  const [isAndroid, setIsAndroid] = useState(false)
  const [osName, setOsName] = useState('other')

  useEffect(() => {
    const UA_LOWERCASE = navigator.userAgent.toLowerCase()
    setIsIOS(!!UA_LOWERCASE.match(/ipad|ipod|iphone/i))
    setIsAndroid(!!UA_LOWERCASE.match(/android/i))
  }, [])

  useEffect(() => {
    setOsName(isIOS ? 'iOS' : isAndroid ? 'Android' : 'other')
  }, [isIOS, isAndroid])

  return { isIOS, isAndroid, osName }
}
